import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { VoidResponse } from '@lsq-frontend/remote-services/enterprise/common';

export class UpdatePurchaseRequestStatusRequest {
    purchaseRequestId: string;
    soldDate: string;
    status: PurchaseRequestStatus;
}

export enum PurchaseRequestStatus {
    PENDING_SALE = 'PENDING_SALE',
    SOLD = 'SOLD'
}

@Injectable({ providedIn: 'root' })
export class UpdatePurchaseRequestService extends ApiService<
    UpdatePurchaseRequestStatusRequest,
    VoidResponse
> {
    requestType = UpdatePurchaseRequestStatusRequest;
    responseType = VoidResponse;
    endpointName = 'v1/updatePurchaseRequestStatus';
    serviceName = 'fundingApi';
    usePascalForUrl = false;

    constructor(_http: HttpClient, @Inject(SETTINGS) _settings: ISettings) {
        super(_http, _settings);
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
